export const makeSocket = (thngId) =>
	window.evrythngToken.thng(thngId).action('authenticationResults');

const authenticationResultsApi = {
	retrieve: (thngId, count = 1) => makeSocket(thngId).read(count),
	subscribe: async (thngId, onMessage) => {
		const socket = makeSocket(thngId);
		await socket.subscribe(onMessage);
		return socket;
	},
};

export default authenticationResultsApi;
